/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Stack, Text } from '@towersystems/towersystems-design-system';
import { map, get, compact } from 'lodash';
import { connect } from 'react-redux';
import { Table } from 'antd';
import DropdownLink from 'components/dropdown-link';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import Button from 'components/button';
import AnnotatedSection from 'components/annotated-section';
import FormInputCheckbox from 'components/forms/form-checkbox';
import ExportSale from './export-sale';
import ExportMetaData from './export-meta-data';
import GeneralSettings from './general-settings';
import SalesType from './sales-type';
import FormTextInput from 'components/forms/form-text-input';
import FormLabel from 'components/forms/form-label';
import cecSdk from 'lib/customer-ec-sdk';
import JumpingDots from 'components/jumping-dots';
import { requestConnectionPaymentTypes } from 'state/connection-payment-types/actions';
import { requestConnectionWebhooks } from 'state/connection-webhooks/actions';
import { getConnectionWebhooks } from 'state/connection-webhooks/selectors';
import { requestConnectionRetailerSalesTypes } from 'state/connection-retailer-sales-types/actions';
import { requestConnectionRetailerPayTypes } from 'state/connection-retailer-pay-types/actions';
import { requestConnectionSalesTypes } from 'state/connection-sales-types/actions';
import EditSalesTypesModal from 'blocks/edit-sales-types-modal';
import { startMappingSalesTypes, deleteMappingSalesTypes, stopMappingSalesTypes } from 'state/ui/sales-types-modal/actions';
import Tag from 'components/tag';
import SalesTypesList from './sales-types/sales-types-list';
import {successNotice} from 'state/notices/actions';

const WooCommerceRender = ({
	handleOnGeneralSettingsChange,
	handleOnChangeInputBox,
	exportNewSales,
	handleOnChangeCheckbox,
	connectionGroupCode,
	terminals,
	paytypes,
	values,
	metaData,
	connectionId,
	connectionType,
	...props
}) => {
	const [connectionWebhooks, setConnectionWebhooks] = useState([]);
	const [connectionPaymentTypes, setConnectionPaymentTypes] = useState([]);
	const [connectionRetailerSalesTypes, setConnectionRetailerSalesTypes] = useState([]);
	const [connectionRetailerPayTypes, setConnectionRetailerPayTypes] = useState([]);
	const [connectionSalesTypes, setConnectionSalesTypes] = useState([]);
	const [requesting, setRequesting] = useState(true);
	const [requestingConnectionPaymentTypes, setRequestingConnectionPaymentTypes] = useState(true);
	const [requestingConnectionRetailerSalesTypes, setRequestingConnectionRetailerSalesTypes] = useState(true);
	const [requestingConnectionRetailerPayTypes, setRequestingConnectionRetailerPayTypes] = useState(true);
	const [requestingConnectionSalesTypes, setRequestingConnectionSalesTypes] = useState(true);
	const [disabling, setdDisabling] = useState(false);
	const [enabling, setEnabling] = useState(false);
	const [testing, setTesting] = useState(false);
	const [importing, setImporting] = useState(false);
	const [hookResponse, setHookResponse] = useState(null);
	const [importResponse, setImportResponse] = useState(null);
	const [hide, setdHide] = useState(false);

	useEffect(() => {
		loadWebhookData(connectionId);
		loadPaymentTypesData(connectionId);
		loadRetailerSalesTypesData(connectionId);
		loadRetailerPayTypesData(connectionId);
		loadSalesTypesData(connectionId);
	}, []);

	const loadWebhookData = async (connectionId) => {
		setRequesting(true);

		try {
			//let connection = await props.requestConnection(connectionId);
			let connectionWebhooks = await props.requestConnectionWebhooks(connectionId);
			map(connectionWebhooks, (connectionWebhook) => {
				connectionWebhook.webhook_enabled == 1 ? setdHide(true) : setdHide(false);
			});
			setConnectionWebhooks(connectionWebhooks);
		} catch (error) {}

		setRequesting(false);
	};

	const disableWebhook = async () => {
        setdDisabling(true);

        try {
            let hookResponse = await cecSdk.connection(connectionId).deleteWebhook({ connectionDetails: get(values, 'connection_details') });
            setHookResponse(hookResponse);

            if (hookResponse.status == 200) {
                props.successNotice(hookResponse.title);
                loadWebhookData(connectionId);
            } else {
                props.errorNotice(hookResponse.title);
            }
        } catch (error) {
            props.errorNotice('Unknown error occoured.');

        }
        setdDisabling(false);
    };

	const testWebhookOrderCreation = async () => {
        setTesting(true);
        try {
            let hookResponse = await cecSdk.connection(connectionId).testWebhookOrderCreation({ connectionDetails: get(values, 'connection_details') });
            setHookResponse(hookResponse);

            if (hookResponse.status == 200) {
                props.successNotice(hookResponse.title); 
                loadWebhookData(connectionId);
            } else {
                props.errorNotice(hookResponse.title);
            }
        } catch (error) {
            props.errorNotice('Unknown error occoured.');

        }
        setTesting(false);
    };

	const enableWebhookOrderCreation = async () => {
        setEnabling(true);
        try {
            let hookResponse = await cecSdk.connection(connectionId).testWebhookOrderCreation({ connectionDetails: get(values, 'connection_details') });
            setHookResponse(hookResponse);

            if (hookResponse.status == 200) {
                props.successNotice(hookResponse.title); 
                loadWebhookData(connectionId);
            } else {
                props.errorNotice(hookResponse.title);
            }
        } catch (error) {
            props.errorNotice('Unknown error occoured.');

        }
        setEnabling(false);
    };

	const loadPaymentTypesData = async (connectionId) => {
		setRequestingConnectionPaymentTypes(true);
		
		try {
			let connectionPaymentTypes = await props.requestConnectionPaymentTypes(connectionId);
			setConnectionPaymentTypes(connectionPaymentTypes);
		} catch (error) {}

		setRequestingConnectionPaymentTypes(false);
	};

	const loadRetailerSalesTypesData = async (connectionId) => {
		setRequestingConnectionRetailerSalesTypes(true);
		
		try {
			let connectionRetailerSalesTypes = await props.requestConnectionRetailerSalesTypes(connectionId);
			setConnectionRetailerSalesTypes(connectionRetailerSalesTypes);

			//console.log(connectionRetailerSalesTypes);
		} catch (error) {}

		setRequestingConnectionRetailerSalesTypes(false);
	};

	const loadRetailerPayTypesData = async (connectionId) => {
		setRequestingConnectionRetailerPayTypes(true);
		
		try {
			let connectionRetailerPayTypes = await props.requestConnectionRetailerPayTypes(connectionId);
			setConnectionRetailerPayTypes(connectionRetailerPayTypes);

			//console.log(connectionRetailerPayTypes);
		} catch (error) {console.log(error);}

		setRequestingConnectionRetailerPayTypes(false);
	};

	const loadSalesTypesData = async (connectionId) => {
		setRequestingConnectionSalesTypes(true);
		
		try {
			let connectionSalesTypes = await props.requestConnectionSalesTypes(connectionId);
			setConnectionSalesTypes(connectionSalesTypes);

			//console.log(connectionSalesTypes);
		} catch (error) {console.log(error);}

		setRequestingConnectionSalesTypes(false);
	};

	const importPaymentTypes = async () => {
        setImporting(true);
        try {
            let importResponse = await cecSdk.connection(connectionId).importPaymentTypes({ connectionDetails: get(values, 'connection_details') });
            setImportResponse(importResponse);

            if (importResponse.status == 200) {
                props.successNotice(importResponse.title); 
                loadSalesTypesData(connectionId);
            } else {
                props.errorNotice(importResponse.title);
            }
        } catch (error) {
            props.errorNotice('Unknown error occoured.');

        }
        setImporting(false);
    };

	const dataSource = map(connectionSalesTypes, (r) => {
		return r;
	});

	const columns = [
		{
			title: 'Web Payment Type',
			key: 'web_payment_type',
			dataIndex: 'web_payment_type',
			render: (a) => {
				return <Text>{a}</Text>;
			},
		},
		{
			title: 'Retailer Sales Type',
			key: 'retailer_sales_type',
			dataIndex: 'retailer_sales_type',
			render: (a) => {
				return <Text>{a}</Text>;
			},
		},
		{
			title: 'Retailer Payment Method',
			key: 'retailer_payment_type',
			dataIndex: 'retailer_payment_type',
			render: (a) => {
				return <Text>{a}</Text>;
			},
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (a) => {
				return (
					(a.retailer_sales_type != '' || a.retailer_payment_type !='') ?
					<DropdownLink
						title='Actions'
						items={compact([
							{
								label: 'Edit',
								key: 'edit_data',
								onClick: () => props.startMappingSalesTypes(a.id),
							},
							{
								label: 'Delete',
								key: 'delete_data',
								onClick: () => {
									props.deleteMappingSalesTypes(a.id); 
									props.successNotice("Deleted");
									loadSalesTypesData(connectionId);
								},
							},
						])}
					/> : 
					<DropdownLink
						title='Actions'
						items={compact([
							{
								label: 'Add',
								key: 'add_data',
								onClick: () => props.startMappingSalesTypes(null, { connection: connectionId, connection: connectionId, web_payment_type: a.web_payment_type, web_payment_code: a.web_payment_code }),
							},
						])}
					/>
				)
			},
		},
	];

	const onSuccess = () => {
		props.stopMappingSalesTypes();
		props.successNotice('Saved');
		loadSalesTypesData(connectionId);
	};

	const onDeleted = () => {
		props.stopMappingSalesTypes();
		props.successNotice('Deleted');
		loadSalesTypesData(connectionId);
	};
	
	return (
		<Stack space='medium'>
			<Stack space='xlarge' dividers>
				<AnnotatedSection>
					<AnnotatedSection.Annotation
						title='General settings'
						description='Configure how sales from your eCommerce platform are treated by Retailer'
					/>
					<AnnotatedSection.Content>
						<Stack space='xlarge'>
							<Card>
								<GeneralSettings
									onChange={handleOnGeneralSettingsChange}
									locations={props.locations}
									terminals={terminals}
									paytypes={paytypes}
									groupCode={connectionGroupCode}
									connectionType={connectionType}
									defaultValues={{
										salesPayType: get(values, 'salesPayType', ''),
										salesPayTypeVoucher: get(values, 'salesPayTypeVoucher', ''),
										salesRegister: get(values, 'salesRegister', ''),
										salesFulfillmentLocation: get(values, 'salesFulfillmentLocation', ''),
										salesStaffInitials: get(values, 'salesStaffInitials', ''),
									}}
								/>
							</Card>
						</Stack>
					</AnnotatedSection.Content>
				</AnnotatedSection>

				<AnnotatedSection>
					<AnnotatedSection.Annotation
						title='Webhooks'
						description='Configure webhooks in your eCommerce platform.'
					/>
					<AnnotatedSection.Content>
						<Stack space='xlarge'>
							{map(connectionWebhooks, (connectionWebhook) => {
								return (
									<Card.Section key={connectionWebhook.webhook_id}>
										<Box display='flex' alignItems='center' justifyContent='spaceBetween'>
											<Box>
												<Text>
												Scope: {connectionWebhook.webhook_topic.toLowerCase()}&nbsp; 
												{connectionWebhook.webhook_enabled == 1 ?
												<Tag className="tag--enabled"> Enabled</Tag>
												: <Tag className="tag--disabled"> Disabled</Tag>}
												</Text>
											</Box>

										</Box>
									</Card.Section>
								);
							})}
							<Card>
								<Card.Section>
									<Box display='flex' alignItems='center' justifyContent='spaceBetween'>
										<Text>Test webhook for order creation</Text>
										<Button disabled={testing} onClick={testWebhookOrderCreation}>
											{testing ? <div>Testing webhook connection <JumpingDots /></div> : 'Test webhook connection'}
										</Button>
									</Box>
								</Card.Section>
							</Card>
							{hide == true ?
							<Card>
								<Card.Section>
									<Box display='flex' alignItems='center' justifyContent='spaceBetween'>
										<Text>Disable webhook for order creation</Text>
										<Button disabled={disabling} onClick={disableWebhook}>
											{disabling ? <div>Disabling webhook connection <JumpingDots /></div> : 'Disable webhook connection'}
										</Button>
									</Box>
								</Card.Section>
							</Card> : <Card>
								<Card.Section>
									<Box display='flex' alignItems='center' justifyContent='spaceBetween'>
										<Text>Enable webhook for order creation</Text>
										<Button disabled={enabling} onClick={enableWebhookOrderCreation}>
											{enabling ? <div>Enabling webhook connection <JumpingDots /></div> : 'Enable webhook connection'}
										</Button>
									</Box>
								</Card.Section>
							</Card>}
						</Stack>
					</AnnotatedSection.Content>
				</AnnotatedSection>

				<AnnotatedSection>
					<AnnotatedSection.Annotation
						title='Automatic sales export'
						description='Configure how sales are exported from your eCommerce platform.'
					/>
					<AnnotatedSection.Content>
						<Stack space='xlarge'>
							<Card>
								<Card.Section>
									<FormInputCheckbox
										label='Automatic sales export'
										onChange={handleOnChangeCheckbox}
										name='automaticSalesExport'
										checked={get(values, 'automaticSalesExport', false)}
									>
										When ticked, new sales marked as <b>paid</b> will automatically be downloaded
										from your eCommerce platform.
										<br />
										<b>Do not use this setting if you have set up webhooks.</b>
									</FormInputCheckbox>
								</Card.Section>
							</Card>
							<Card>
								<Card.Section>
									<FormLabel>Start Date:</FormLabel>
									<Text size='xsmall'>
										The start date you would like to export order from. Please use format YYYY-MM-DD
										HH:MM:SS (in 24 hour time). When leave blank, orders newer than current time
										will be exported by default.
									</Text>
									<FormTextInput
										name='saleStartDate'
										value={get(values, 'saleStartDate')}
										onChange={handleOnChangeInputBox}
									/>
								</Card.Section>
							</Card>
							<Card>
								<Card.Section>
									<ExportMetaData exportNewSales={exportNewSales} metaData={metaData} />
								</Card.Section>
							</Card>
						</Stack>
					</AnnotatedSection.Content>
				</AnnotatedSection>
				<AnnotatedSection>
					<AnnotatedSection.Annotation
						title='Manual sales export'
						description='Manually check for new sales from your eCommerce platform using identifier.'
					/>
					<AnnotatedSection.Content>
						<Stack space='xlarge'>
							<Card>
								<Card.Section>
									<ExportSale connectionId={connectionId} connectionType={connectionType} />
								</Card.Section>
							</Card>
						</Stack>
					</AnnotatedSection.Content>
				</AnnotatedSection>
				<EditSalesTypesModal
					connectionSalesTypes={connectionSalesTypes}
					connectionId={connectionId}
					connectionType={connectionType} 
                    retailerSalesTypes={connectionRetailerSalesTypes}
					retailerPaymentTypes={connectionRetailerPayTypes}
					webPaymentTypes={connectionPaymentTypes}
					onSuccess={onSuccess}
					onDeleted={onDeleted}
				/>
			</Stack>
		</Stack>
	);
};

export default connect((state, ownProps) => ({
	connectionWebhooks: getConnectionWebhooks(state, ownProps.connectionId),
}), {
	requestConnectionPaymentTypes,
	requestConnectionRetailerSalesTypes,
	requestConnectionWebhooks,
	requestConnectionRetailerPayTypes,
	requestConnectionSalesTypes,
	startMappingSalesTypes,
	deleteMappingSalesTypes,
	stopMappingSalesTypes,
    successNotice,
})(WooCommerceRender);
